import { Navigate } from "react-router-dom";
import AddDesignation from "./addDesignation";
import GetAllDesignation from "./getAllDesignation";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { Col, Row, Form } from "antd";
import { useState } from "react";

const Designation = (props) => {
  // Move Hooks to the top, before any early returns
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentDesignationId, setCurrentDesignationId] = useState(0);

  // Now perform the conditional check
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  return (
    <div className="add-designation-page-wrapper">
      <Row gutter={16} className="add-designation-row">
        {/* Left Side - Add Designation */}
        <Col xs={14} sm={14} md={8} lg={8} className="add-designation-form-col">
          <AddDesignation
            form={form}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            currentDesignationId={currentDesignationId}
            setCurrentDesignationId={setCurrentDesignationId}
          />
        </Col>

        {/* Right Side - Designation List */}
        <Col xs={24} sm={24} md={16} lg={16} className="add-designation-table-col">
          <GetAllDesignation
            form={form}
            setIsEditMode={setIsEditMode}
            setCurrentDesignationId={setCurrentDesignationId}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Designation;